
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//克罗地亚
export const lang ={
  Please_set_materialtype_in_product_page:"Idite na stranicu proizvoda kako biste izmijenili i postavili vrstu materijala za svaki proizvod - gotovi proizvodi - poluproizvodi - pribor.",
deleteAccount:"Odjavite se",
deleteAccountWillDeleteAllData:"Odjavom s računa izbrisat ćete sve podatke i onemogućiti ćete se prijaviti.",
backupDatabase:"rezervna baza podataka",
restoreDatabase:"Vrati bazu podataka",
materialtype:"Vrsta materijala",
Manufacturing:"Proizvodna verzija",
Professional:"Profesionalna verzija",
Standard:"Standardno izdanje",
product:"Gotov proizvod",
halfProduct:"Poluproizvodi",
components:"Pribor",
Parent:"nadređena komponenta",
Children:"Podpribor",
Level:"Hijerarhija",
Timing:"Vrijeme",
PieceCount:"Rad plaćen na akord",
Wages:"plaće",
InternalProcess:"Interni proces",
ExternalProcess:"vanjski proces",
ProceName:"Naziv procesa",
ProceIndex:"Nalog za izvršenje",
ChargeMan:"glavni",
BillMethod:"Način naplate",
ConsumTime:"radni sati",
Accessories:"Pribor",
Assembly:"Sastavite",
materials:"materijala",
task:"Zadatak",
process:"postupak",
BOM:"BOM",
Production:"Proizvodnja",
RestorePurchaseOneUse:"Vrati kupnju (jedan korisnik (ograničeno na prethodne kupnje))",
buy_fail_try_again:"Kliknite ponovo za kupnju",
Export:"Izvoz",
Date:"datum",
BankDetail:"bankovni detalji",
Seller:"prodavač",
Buver:"kupac",
Currency:"valuta",
CompanyName:"Naziv tvrtke",
ProformaInvoice:"predračun",
Discount:"Popust",
PayStatus:"Status plaćanja",
ShippingStatus:"Status otpreme",
FreightType:"Vrsta prijevoza",
Shipping:"teretni",
Payment:"Plaćanje",
Moneyname:"naziv valute",
Tax:"porezi",
Freight:"Troškovi prijevoza",
Insurance:"osiguranje",
Bankfee:"bankovne naknade",
Qc:"Certifikacija kvalitete",
Exchangerate:"devizni tečaj",
Shippingnumber:"broj pošiljke",
ShipDate:"Datum slanja",
Arrivedate:"Datum dolaska",
Grossweight:"bruto težina",
CubicWeight:"kubična težina",
Totalpackages:"Ukupan broj paketa",
Moneytype:"vrsta valute",
Quotedate:"datum citata",
Validitydate:"Valjani datum",
Paymentterm:"istek plaće",
Priceterm:"cjenovni termin",
DeliveryTerm:"Vrijeme isporuke",
BankName:"ime banke",
BankAddress:"adresa banke",
SwiftCode:"Bankovni kod",
Review:"Pregled",
Signfor:"Potpišite za primitak",
Finance:"financije",
Receiver:"Prijamnik",
Business:"poslovanje",
ContactPerson:"Osoba za kontakt",
Profit:"dobit",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"Zaposlenici moraju koristiti Google Chrome. Molimo provjerite IP adresu na stranici za pomoć glavnog servisnog računalnog APP-a, a zatim unesite adresu u URL stupac drugih preglednika računala kako biste otvorili prijavu",
newPassword:"Nova lozinka",
ForgetPassword:"zaboraviti lozinku",
ContactUs:"Kontaktirajte nas/dajte prijedloge",
Actualpay_should_big_then_shouldpay:"Stvarni primici ne mogu biti veći od potraživanja",
ShopAddress:"Adresa moje trgovine Skenirajte QR kod da biste naručili",
Submit:"podnijeti",
All:"svi",
OrdernumExists:"Broj narudžbe već postoji",
PermissionDenied:"dopuštenje odbijeno",
StockTransfer:"Prijenos zaliha",
FromWarehouse:"Prijenos izvan skladišta",
ToWarehouse:"Transfer u skladište",
PleaseUseInWebBrowser:"Koristite Excel funkciju izvoza u pregledniku Google Chrome",
PleasePrintInWebBrowser:"Koristite funkciju ispisa u pregledniku Google Chrome",
HistoryPrice:"povijesna cijena",
SerialNumber:"serijski broj",
Please_Use_In_APP:"Koristite ga unutar računalnog softvera",
Please_Purchase_In_APP:"Kupujte unutar APP-a, ne unutar preglednika",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Možete se povezati s Postgresql bazom podataka. Vaši će podaci biti pohranjeni u Postgresql bazi podataka. Prema zadanim postavkama, ne morate se povezati s Postgresql bazom podataka. Zadana je lokalna Sqlite baza podataka.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Povežite se s Postgresql bazom podataka, vaši će podaci biti pohranjeni u Postgresql bazi podataka, a podaci će se ponovno čitati",
Use_sqlite_data_will_store_in_local:"Koristeći sqlite, podaci će biti pohranjeni na lokalnom računalu",
UsePostgresqlDatabase:"Korištenje PGSQL baze podataka",
UseSqliteDatabase:"Korištenje Sqlite baze podataka",
DatabaseName:"Baza podataka imena",
Test_connect:"testna veza",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Ukoliko proizvod ima boju ili veličinu, za početni inventar upišite 0. Nakon dodavanja proizvoda unesite inventar u kupnju.",
my:"rudnik",
my_shop_qrcode_scan:"QR kod moje trgovine pruža kupcima mogućnost skeniranja koda za naručivanje. Kupčev mobilni telefon mora biti povezan na isti ruter kao i vaše računalo.",
ip:"IP",
port:"Luka",
orderstatus:"Stanje narudžbe",
image:"slika",
Template:"predložak",
Please_select_a_excel_file:"Odaberite datoteku",
Please_select_only_one_excel_file:"Može se odabrati samo jedna datoteka",
Connect_Internet_Login_again:"Spojite se na internet i ponovno se prijavite prije kupnje",

    productHasValidDate:'Proizvod ima valjano razdoblje',
productHasColor:'Proizvod ima veličinu boje',
GeneralGoods:'Opća roba',
Selected:'odabran',
RestorePurchase:'Nastavi kupnju',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Kupite Invoicing Enterprise Edition 1 korisnika trajno',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Kupnja Izdanje fakturiranja Enterprise Edition je neograničeno za korisnike i uređaje',
Purchasing:'Kupnja ... Pričekajte strpljivo ...',
Validdate:'Razdoblje valjanosti',
Makedate:'Datum proizvodnje',
Batch:'serija',
CheckVersion:'Provjerite verziju',
Please_set_this_ip_address_on_App:'Postavite ovu IP adresu ili IP adresu računala na APP.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Otvorite ovu vezu na računalu ili mobilnom pregledniku (povežite isti WiFi)',


    CheckVersion: "Provjeri verziju",
You_need_to_purchase: 'Još niste kupili, molimo dodajte WeChat Elink9988 E-mail: bvbuy@qq.com',
Thank_for_your_purchase: "Već ste kupili",
New_version_available: "Postoji nova verzija",
Is_the_latest_version: 'je najnovija verzija',

    please:'Molim',
input:'ulazni',
wrong:'pogrešno',
Verifycode:'Potvrdite kôd',
Upload:'Učitaj',
Download:'preuzimanje datoteka',
You_need_to_purchase_to_continue_use:'Morate kupiti da biste nastavili koristiti',
CheckBuy:'Provjerite kupnju',
Exists:'postoji',
NetworkUnavailable:'Mreža nije dostupna',
Today:'Danas',
Yesterday:'Jučer',
ThisMonth:'Ovaj mjesec',
LastMonth:'Prošli mjesec',
nickname:'nadimak',
storeName:'pohrani ime',
BuyStandAlone:'Kupite samostalnu verziju',
PermissionDenied:'Dozvola je odbijena',
Boss:'Boss',
    login:'Prijaviti se',
operate:'raditi',
register:'Registrirajte se',
username:'Korisničko ime',
password:'Zaporka',
User:'Korisnik',
ok:'u redu',
back:'leđa',
success:'Uspjeh',
fail:'Iznevjeriti',
cancel:'otkazati',
add:'Dodati',
edit:'Uredi',
delete:'Izbrisati',
refresh:'Osvježiti',
close:'Zatvoriti',
cancel:'Otkazati',
return:'Povratak',
ElinkInvoice:'Elink faktura',
Purchase:'Kupiti',
BaseData:'Osnovni podaci',
Sell:'Prodati',
PurchaseReturns:'Povrat kupnje',
SellReturns:'Prodaj vraća',
Inventory:'Inventar',
Statistics:'statistika',
Receivable:'potraživanja',
Payable:'plativ',
Orders:'Narudžbe',
StockTransfer:'Prijenos zaliha',
StockRecall:'Povrat dionica',
Customer:'kupac',
Supplier:'Dobavljač',
Warehouse:'Skladište',
Color:'Boja',
Size:'Veličina',
Category:'Kategorija',
Category2:'kategorija2',
Product:'Proizvod',
Account:'Račun',
AccountType:'Kategorija računa',
Staff:'Osoblje',
typeone:'Kategorija',
typetwo:'Podkategorija',
ProductName:'Ime proizvoda',
Specification:'Specifikacija',
Barcode:'Barkod',
Buyprice:'Kupite cijenu',
Sellprice:'Prodajna cijena',
Wholesaleprice:'Veleprodajna cijena',
Currentstock:'Struje su točne',
Unit:'Jedinica',
Initstock:'Init zaliha',
Parameter:'Parametar',
Remark:'Napomena',
Supplier:'Dobavljač',
Customer:'kupac',
Staff:'Osoblje',
Receivable:'potraživanja',
payable:'plativ',
Receipts:'potvrde',
Paid:'plaćen',
Preferential:'povlašćen',
DateDay:'Datum',
OrderNum:'Broj narudžbe',
Name:'Ime',
UserName:'Korisničko ime',
IdNum:'ID broj',
BirthDay:'Rođendan',
SEX:'Seks',
Female:'Žena',
Male:'Muški',
Select:'Odaberi',
Address:'Adresa',
Phone:'Telefon',
Email:'E-mail',
CardNum:'Broj kartice',
Price:'Cijena',
QTY:'Kol',
SupplierCategory:'Kategorija dobavljača',
CustomerCategory:'Kategorija kupca',
Power:'Vlast',
Role:'Uloga',
save:'Uštedjeti',
image:'slika',
search:'traži',
Year:'Godina',
Month:'Mjesec',
Day:'Dan',
Total:'ukupno',
WorkReport:'Izvješće o radu',
Leave:'Napustiti',
CheckIn:'Prijaviti se',
Announcement:'Obavijest',
Approval:'Odobrenje',
Tracking:'Praćenje',
Bill:'Račun',
OrdersDetail:'Pojedinosti naloga',
Expense:'Trošak',
Income:'prihod',
Userfor:'Korisnik za',
Amount:'Iznos',
Title:'Titula',
News:'Vijesti',
SelectFile:'Odaberite datoteku',
Content:'Sadržaj',
Cost:'cijena',
ApprovalUser:'Korisnik odobrenja',
ApprovalStatus:'Status odobrenja',
ApprovalRemark:'Napomena o odobrenju',
ApprovalDate:'Datum odobrenja',
SubmitDate:'Datum slanja',
Status:'Status',
FromDateTime:'Od datuma vremena',
ToDateTime:'Do datuma vremena',
Subject:'predmet',
Latitude:'širina',
Longitude:'dužina',
Print:'otisak',
DataTrans:'Prijenos podataka',
OA:'OA',
Setting:'Set',
Help:'Pomozite',
ScanOpenInPhone:'Skeniranje Otvori u telefonu',
Building:'zgrada',
Room:'Soba',
HotelCheckIn:'Prijava',
CheckOut:'Provjeri',
Hotel:'Hotel',
Checkintime:'Provjerite vrijeme',
Checkouttime:'Provjeri vrijeme',
Deposit:'Depozit',
Cost:'cijena',
RoomNum:'Broj soba',
Rent:'Najam',
costday:'costday',
rent:'najam',
waternum:'Stupanj vode',
electricnum:'Električni stupanj',
gasnum:'Stupanj plina',
watercost:'trošak vode',
electriccost:'električni trošak',
gascost:'trošak plina',
cleaningcost:'trošak čišćenja',
networkcost:'trošak mreže',
tvcost:'trošak televizije',
managecost:'upravljanje troškovima',
othercost:'ostale troškove',
totalcost:'Ukupni trošak',
remark:'napomena',
addtime:'dodajte vrijeme',
OpenInBrowser:'Otvori u pretraživaču',
InventoryProfit:'Dobit zaliha',
InventoryLoss:'Gubitak zaliha',
Buy:'Kupiti',



Refresh:'Osvježi',
Add:'Dodaj',
Search:'Traži',
Records:'zapisa',
}



// WEBPACK FOOTER //
// ./src/lang/hr.js